jQuery(function ($) {
  var $checkboxes = $('[name^="franchise"]:checkbox');
  var $franchise_checkbox_container = $("[data-franchise-checkbox-container]");
  var $hidden_placeholder = $franchise_checkbox_container.find("[data-hidden-placeholder]");
  var $hidden_field = "";
  var $checked_checkboxes;

  $checkboxes.on('change', function (e) {
    var values = "";

    $hidden_placeholder.empty();
    $checked_checkboxes = $franchise_checkbox_container.find('[name^="franchise"]:checked');

    $.each($checked_checkboxes, function (i, val) {
      values = values + $(val).val();
    });

    if (values === "") {
      values = "無し";
    }

    $hidden_field = $('<input type="hidden" name="franchises-info">');
    $hidden_placeholder.append($hidden_field.val(values));
  });
});
